// Data residency supported type
export const STORED_EXTERNAL_TO_ATLASSIAN = 'STORED_EXTERNAL_TO_ATLASSIAN';
export const STORED_IN_ATLASSIAN_N_DR_SUPPORTED = 'STORED_IN_ATLASSIAN_N_DR_SUPPORTED';
export const APP_DOES_NOT_SUPPORT_DR = 'APP_DOES_NOT_SUPPORT_DR';
export const STORED_IN_ATLASSIAN_N_DR_NOT_SUPPORTED = 'STORED_IN_ATLASSIAN_N_DR_NOT_SUPPORTED';

// TODO: Update schema & handle for Response not provided & not applicable
// TODO: Also handle which keys should be optional ex: the sub questions